import { PartnerSpotlightModel } from 'v2/types/PartnerSpotlightModel';

type CasinoNameLookup = { id: string; name: string }[] | undefined;

export const filterPartnerSpotlightsByQuery = (
  spotlights: PartnerSpotlightModel[],
  query: string,
  casinos: CasinoNameLookup
): PartnerSpotlightModel[] => {
  const q = query.trim().toLowerCase();
  if (!q) {
    return spotlights;
  }

  return spotlights.filter((spotlight) => {
    const casino = casinos?.find((c) => c.id === spotlight.partnerId);
    const label = spotlight.isBackgroundOnly ? 'background only' : (casino?.name ?? 'partner spotlight').toLowerCase();

    return label.includes(q);
  });
};
